// 解析貼文資料結構

export interface ParsedPost {
  platform: string;        // Instagram, Twitter, Weibo, etc.
  account: string;         // G-Dragon, Taeyang, PEACEMINUSONE, etc.
  dateTime: string;        // 2022-08-19 17:14 (KST)
  caption: string;         // 內文
  instagramUrl: string | null;  // 原始 IG 連結
  tags: string[];          // hashtags
  backupUrl: string | null;     // bigbangmusic.de 備份連結
}

export function parsePostBody(body: string | null, sourceUrl: string | null): ParsedPost {
  const result: ParsedPost = {
    platform: 'Instagram',
    account: '',
    dateTime: '',
    caption: '',
    instagramUrl: null,
    tags: [],
    backupUrl: sourceUrl || null,
  };

  if (!body) return result;

  // 提取平台和帳號
  // Pattern: [Social Media] {Account} {Platform} from ...
  const accountMatch = body.match(/\[Social Media\]\s*(.+?)\s*(Instagram|Twitter|Weibo)/i);
  if (accountMatch) {
    result.account = accountMatch[1].trim();
    result.platform = accountMatch[2];
  }

  // 提取日期時間
  // Pattern: from YYYY-MM-DD HH:MM (KST)
  const dateTimeMatch = body.match(/from\s*(\d{4}-\d{2}-\d{2})\s*(\d{2}:\d{2})?\s*\(?(KST)?\)?/i);
  if (dateTimeMatch) {
    result.dateTime = `${dateTimeMatch[1]}${dateTimeMatch[2] ? ' ' + dateTimeMatch[2] : ''}${dateTimeMatch[3] ? ' (KST)' : ''}`;
  }

  // 提取 Instagram URL
  // Pattern: http(s)://www.instagram.com/p/...
  const igUrlMatch = body.match(/https?:\/\/(?:www\.)?instagram\.com\/p\/[A-Za-z0-9_-]+\/?/i);
  if (igUrlMatch) {
    result.instagramUrl = igUrlMatch[0];
  }

  // 提取 Tags
  // Pattern: Relevant tags: #tag1 #tag2 ...
  const tagsMatch = body.match(/Relevant tags:\s*(.+?)$/i);
  if (tagsMatch) {
    const tagString = tagsMatch[1];
    result.tags = tagString.match(/#[^\s#]+/g) || [];
  }

  // 提取 Caption (內文)
  // Pattern: Caption: {content} 直到 URL 或 Relevant tags
  const captionMatch = body.match(/Caption:\s*([\s\S]*?)(?=https?:\/\/|Relevant tags:|$)/i);
  if (captionMatch && captionMatch[1]) {
    result.caption = captionMatch[1]
      .trim()
      .replace(/\s+/g, ' ');  // 清理多餘空白
  }

  return result;
}

// 格式化標題用於列表顯示
export function formatListTitle(member: string | null, platform: string, caption: string): string {
  const memberName = getMemberDisplayName(member);
  const shortCaption = caption.length > 50 ? caption.substring(0, 50) + '...' : caption;
  return `${memberName} ${platform} ${shortCaption}`.trim();
}

// 取得成員顯示名稱
function getMemberDisplayName(member: string | null): string {
  if (!member) return 'BIGBANG';
  const m = member.toLowerCase();
  if (m.includes('gd') || m.includes('g-dragon')) return 'G-Dragon';
  if (m.includes('taeyang')) return '太陽';
  if (m.includes('top')) return 'T.O.P';
  if (m.includes('daesung')) return '大聲';
  if (m.includes('seungri')) return '勝利';
  return member;
}
